import { render, staticRenderFns } from "./form.vue?vue&type=template&id=620dedbe"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620dedbe')) {
      api.createRecord('620dedbe', component.options)
    } else {
      api.reload('620dedbe', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=620dedbe", function () {
      api.rerender('620dedbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact-list/form.vue"
export default component.exports